import { Navigate } from 'react-router-dom';
import useUserDetails from './hooks/useUserDetails';
import Loader from './reusable/Loader';

interface RestrictedRouteProps {
  children: React.ReactElement;
  allowedRoles: string[];
}

const RestrictedRoute = ({ children, allowedRoles }: RestrictedRouteProps) => {
  const {
    userDetails: { isPending, error, data: userDetails },
  } = useUserDetails();
  const userRole = userDetails?.role;

  if (isPending) return <Loader />;

  if (error || !userRole || !allowedRoles.includes(userRole)) {
    return <Navigate to="/overview" />;
  }

  return children;
};

export default RestrictedRoute;
